export const downloadFile = async (
  orderBuffer: ArrayBuffer,
  fileName: String,
  fileExtension = 'pdf'
) => {
  const url = window.URL.createObjectURL(new Blob([orderBuffer]));
  const link = document.createElement('a');
  link.href = url;
  const now = new Date();
  const hours = now.getHours();
  const minutes = now.getMinutes();
  const seconds = now.getSeconds();

  const day = now.getDate();
  const month = now.getMonth() + 1;
  const year = now.getFullYear();

  const formattedTime = `${hours.toString().padStart(2, '0')}-${minutes
    .toString()
    .padStart(2, '0')}-${seconds.toString().padStart(2, '0')}`;
  const formattedDate = `${day.toString().padStart(2, '0')}-${month
    .toString()
    .padStart(2, '0')}-${year}`;

  const reportName = `${fileName} ${formattedTime} ${formattedDate}.${fileExtension}`;
  link.setAttribute('download', reportName);
  document.body.appendChild(link);
  link.click();
};

export function removeClassFromParent(el: HTMLElement, className: string) {
  el.parentElement?.classList.remove(className);
}
